import configureApp from 'configureApp';

export const baseUrl = `${configureApp.endpoint.atom}/${configureApp.endpoint.pages}/dev/${configureApp.endpoint.sections}`;
